import { useTranslation } from 'react-i18next';

export default function FinalCTASection() {
  const { t } = useTranslation();

  return (
    <section className="bg-background-50 py-16 md:py-28">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-5xl mx-auto">
          <div className="rounded-2xl overflow-hidden h-[300px] md:h-[400px] relative">
            <img
              src="https://readdy.ai/api/search-image?query=Aesthetic%20minimalist%20shopping%20concept%20with%20designer%20sneakers%20and%20accessories%20artistically%20arranged%20on%20warm%20cream%20stone%20surface%2C%20soft%20natural%20light%20with%20subtle%20film%20grain%20texture%2C%20editorial%20fashion%20photography%2C%20warm%20beige%20and%20neutral%20tones%2C%20elegant%20composition%2C%20high%20detail%2C%20sophisticated%20product%20arrangement&width=1400&height=600&seq=yoybuy-final-cta&orientation=landscape"
              alt="YOYBUY Spreadsheet Shopping"
              className="w-full h-full object-cover object-top"
            />
          </div>

          <div className="text-center mt-14">
            <p className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 leading-tight">
              {t('finalCta.title1', 'Готовы начать')}{' '}
              <span className="italic font-light text-foreground-400">{t('finalCta.title2', 'покупать')}</span>{' '}
              {t('finalCta.title3', 'выгодно?')}
            </p>
            <p className="mt-5 text-base text-foreground-600 max-w-md mx-auto">
              {t('finalCta.desc', 'Присоединяйтесь к тысячам покупателей')}
            </p>

            <div className="mt-10">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-3 px-10 py-4 rounded-full bg-foreground-950 text-background-50 font-semibold text-base whitespace-nowrap transition-all duration-300 hover:bg-foreground-800 hover:scale-105 cursor-pointer"
              >
                {t('finalCta.cta', 'Перейти на YOYBUY Sheet')}
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-arrow-right-up-line"></i>
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}